import { render, staticRenderFns } from "./ImotImport.vue?vue&type=template&id=811ec078&scoped=true"
import script from "./ImotImport.vue?vue&type=script&lang=js"
export * from "./ImotImport.vue?vue&type=script&lang=js"
import style0 from "./ImotImport.vue?vue&type=style&index=0&id=811ec078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811ec078",
  null
  
)

export default component.exports